var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.250178 1.61C2.57018 4.59 6.00018 9 6.00018 9V14C6.00018 15.1 6.90018 16 8.00018 16C9.10018 16 10.0002 15.1 10.0002 14V9C10.0002 9 13.4302 4.59 15.7502 1.61C16.2602 0.95 15.7902 0 14.9502 0H1.04018C0.210178 0 -0.259822 0.95 0.250178 1.61Z",
    fill: "#30248B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a913825f30cc02cc80cad968d8dc31c5.svg";
export { ForwardRef as ReactComponent };